import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class SetSrid extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.setsrid',
        group: 'Data Preparation',
        title: 'ST Set SRID',
        description: `
      This component sets the SRID of a geo column.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table',
          optional: true
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geometry]
        },
        {
          name: 'srid',
          type: WorkflowComponentParamType.String,
          title: 'SRID'
        }
      ]
    )
    this.supportedProviders = [
      Provider.Snowflake,
      Provider.Postgres,
      Provider.Redshift
    ]
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.Snowflake:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT *,
                ${connection.processOutputGeogColumn(
                  `ST_SetSRID(${connection.processInputGeogColumn(
                    params.geo as string
                  )}, ${params.srid})`
                )}
                AS ${params.geo}_${params.srid}
              FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_${params.srid}`,
      type: ColumnDataType.Geometry
    })
  }
}

export { SetSrid }
